import React from 'react';
import { AddBankAccountPromptText } from './AddBankAccountPromptText';

export const AutomatedVerificationFlow = () => {
    return (
        <div>
            <AddBankAccountPromptText>
                <ul className="list-disc list-inside text-sm text text-grey-1 p-3">
                    <li>
                        Automatic small deposits from RaiseRight have been sent to your linked bank
                        account. Depending on your bank, the deposits will take 1-2 business days to
                        process.
                    </li>
                    <li>
                        If you encounter issues, please call Customer Support at 1-800-727-4715
                        Option 3.
                    </li>
                </ul>
            </AddBankAccountPromptText>
        </div>
    );
};
